import {GpsShapeType, GpsTrigger, Spot, Zone} from "../../types";
import {useContext} from "react";
import {Box, GridItem, IconButton, Text} from "@chakra-ui/react";
import {BiTrash} from "react-icons/bi";
import {AppContext, AppContextI} from "../../context/ContextWrapper";
import {useConfirmDialog} from "../../common/ConfirmDialogProvider";

type Props = {
    object: Spot | Zone,
    trigger: GpsTrigger,
    index: number,
    updateCall: (object?: Spot | Zone, newObject?: Spot | Zone) => void,
    onDelete?: (object: Spot | Zone, trigger: GpsTrigger) => void
}

const GpsTriggerDetails = ({object, trigger, updateCall, onDelete}: Props) => {
    const appContext: AppContextI = useContext<AppContextI>(AppContext);
    const {confirm} = useConfirmDialog();

    return <>
        <GridItem marginTop={"16px"} colSpan={4}/>
        <GridItem colStart={1}><Text fontWeight={"semibold"}>{trigger.shapeType === GpsShapeType.Circle ? "GPS Circle:" : "GPS Area:"}</Text></GridItem>
        <Box/>
        <Box/>
        <IconButton variant={"ghost"} aria-label={"Delete"} icon={<BiTrash/>} onClick={async () => {
            const approved = await confirm({
                title: "Delete trigger",
                body: "Are you sure you want to delete this trigger?",
                confirmText: "Delete",
                isDestructive: true
            });
            if (!approved) {
                return;
            }
            if (onDelete) {
                onDelete(object, trigger);
                return;
            }
            const newTriggers = [...object.gpsTriggers ? object.gpsTriggers : []]
            const gpsTriggers = newTriggers.filter((gpsTrgger: GpsTrigger) => gpsTrgger.id !== trigger.id);

            updateCall(object, {
                ...object,
                gpsTriggers: gpsTriggers
            } as Spot);
        }}
                    disabled={!appContext.isDraft()}
        />
    </>;
}

export default GpsTriggerDetails;